/**
 * The IoT tag device linked under an asset in the history-report payload
 * (GET /common/report/:id), or null. A device counts only when its asset model
 * is a tag device AND it carries a tagDeviceId (the GPRS/IMEI).
 */
export const findLinkedIotDevice = (reportData) => {
  const linked = reportData && reportData.dependentLinkedAsset;
  if (!linked || !linked.length) return null;
  return linked.find(a => a.assetModel && a.assetModel.isTagDevice && a.tagDeviceId) || null;
};

/**
 * The devices that make the Live / BLE Live buttons appear on the asset report,
 * using the same rule as QuickActionBar: a device in dependentLinkHistory whose
 * model is a tag device (with tagDeviceId) or a BLE tag (with bleTagId) and whose
 * current parent is this asset. Returns { taggedDeviceAsset, bleTagAsset } (null when absent).
 */
export const findLiveTrackDevices = (reportData) => {
  const { asset, dependentLinkHistory } = reportData || {};
  const result = { taggedDeviceAsset: null, bleTagAsset: null };
  if (!asset || !dependentLinkHistory || !dependentLinkHistory.length) return result;
  const isChild = (a) => a.subasset && a.subasset.parent && a.subasset.parent.toString() === asset._id.toString();
  const tag = dependentLinkHistory.find(a => isChild(a) && a.subasset.assetModel
    && a.subasset.assetModel.isTagDevice && a.subasset.tagDeviceId);
  const ble = dependentLinkHistory.find(a => isChild(a) && a.subasset.assetModel
    && a.subasset.assetModel.isBleTag && a.subasset.bleTagId);
  result.taggedDeviceAsset = tag ? tag.subasset : null;
  result.bleTagAsset = ble ? ble.subasset : null;
  return result;
};
